import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { API } from 'api';

import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiName, apiBasePath } from 'assets';
import { getMainAccountId } from 'store/account';
import { ActivePractitioner } from 'types/PractitionerUser';

export async function getActivePractitioners() {
  const response = await API.get(
    apiName,
    `${apiBasePath}/practitioners`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.ACCOUNT,
        domain: DOMAINS.PRACTITIONERS,
        importance: IMPORTANCE.MEDIUM,
      },
    },
  );
  return response?.result;
}

const useActivePractitioners = () => {
  const mainAccountId = useSelector(getMainAccountId);
  const practitionersDataQuery = useQuery<ActivePractitioner[]>({
    queryKey: [apiName, `activePractitioners`, mainAccountId],
    queryFn: () => getActivePractitioners(),
    ...{},
  });

  return practitionersDataQuery;
};

export default useActivePractitioners;
